import { CheckCircle, Calendar, Paperclip, FileCheck, FileText, Box, Truck, Tag, Trash2 } from "lucide-react";

export default function MailingCard({
  mailing,
  isSelected,
  onSelect,
  onClick,
  hasShipments,
  onPackBoxes,
  onDeliver,
  onShip,
  onViewShipment,
  onPreviewPDF,
  onDelete,
  generatingPDF
}) {
  return (
    <div 
      className="card" 
      style={{ 
        padding: "1rem",
        cursor: "pointer",
        transition: "transform 0.2s, box-shadow 0.2s"
      }}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.1)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.06)";
      }}
    >
      <div style={{ marginBottom: "0.75rem" }}>
        <div style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem", marginBottom: "0.5rem" }}>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={(e) => {
              e.stopPropagation();
              onSelect();
            }}
            onClick={(e) => e.stopPropagation()}
            style={{ width: "16px", height: "16px", cursor: "pointer", marginTop: "0.25rem", flexShrink: 0 }}
          />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.25rem" }}>
              <h3 style={{ 
                fontSize: "1rem", 
                fontWeight: 600, 
                color: "#1e293b",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1
              }}>
                {mailing.mailing_name}
              </h3>
              {hasShipments && (
                <span style={{
                  background: "#dcfce7",
                  color: "#166534",
                  padding: "0.125rem 0.5rem",
                  borderRadius: "12px",
                  fontSize: "0.65rem",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  gap: "0.25rem",
                  flexShrink: 0
                }}>
                  <CheckCircle size={10} />
                  SHIPPED
                </span>
              )}
            </div>
            <div style={{ fontSize: "0.75rem", color: "#64748b" }}>
              <div>Order: {mailing.order_number}</div>
              <div style={{ display: "flex", alignItems: "center", gap: "0.25rem", marginTop: "0.25rem" }}>
                <Calendar size={12} />
                {new Date(mailing.created_at).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div style={{ 
        padding: "0.5rem", 
        background: "#f8fafc", 
        borderRadius: "6px",
        marginBottom: "0.75rem",
        fontSize: "0.75rem"
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.25rem" }}>
          <span style={{ color: "#64748b" }}>Post Offices:</span>
          <strong>{mailing.post_office_count ?? 0}</strong>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.25rem" }}>
          <span style={{ color: "#64748b" }}>Routes:</span>
          <strong>{mailing.route_count ?? 0}</strong>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.25rem" }}>
          <span style={{ color: "#64748b" }}>Pieces:</span>
          <strong>{(mailing.total_pieces || 0).toLocaleString()}</strong>
        </div>
        {mailing.box_packing && (
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.25rem" }}>
            <span style={{ color: "#10b981" }}>
              {mailing.box_packing.container_type === "Tray" ? "Trays:" : "Boxes:"}
            </span>
            <strong style={{ color: "#10b981" }}>{mailing.box_packing.total_boxes}</strong>
          </div>
        )}
        {mailing.document_count > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.25rem" }}>
            <span style={{ color: "#f59e0b" }}>
              <Paperclip size={10} style={{ display: "inline", marginRight: "0.25rem" }} />
              Documents:
            </span>
            <strong style={{ color: "#f59e0b" }}>{mailing.document_count}</strong>
          </div>
        )}
        {mailing.acceptance_pdf_template && (
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.25rem" }}>
            <span style={{ color: "#8b5cf6" }}>
              <FileCheck size={10} style={{ display: "inline", marginRight: "0.25rem" }} />
              Acceptance:
            </span>
            <strong style={{ color: "#8b5cf6" }}>✓</strong>
          </div>
        )}
        {mailing.postage_statement_template && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: "#0ea5e9" }}>
              <FileText size={10} style={{ display: "inline", marginRight: "0.25rem" }} />
              Postage Stmt:
            </span>
            <strong style={{ color: "#0ea5e9" }}>✓</strong>
          </div>
        )}
      </div>

      {/* Action Buttons */}
      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        {!mailing.box_packing && !hasShipments && (
          <button
            className="btn btn-sm btn-primary"
            onClick={(e) => {
              e.stopPropagation();
              onPackBoxes();
            }}
            style={{ width: "100%", fontSize: "0.75rem", padding: "0.5rem" }}
          >
            <Box size={14} />
            Pack Boxes
          </button>
        )}
        {mailing.box_packing && !hasShipments && (
          <>
            {mailing.box_packing.container_type === "Tray" ? (
              <button
                className="btn btn-sm"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeliver();
                }}
                style={{ 
                  width: "100%", 
                  fontSize: "0.75rem", 
                  padding: "0.5rem",
                  background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                  color: "white",
                  border: "none"
                }}
              >
                <CheckCircle size={14} />
                Deliver
              </button>
            ) : (
              <button
                className="btn btn-sm btn-primary"
                onClick={(e) => {
                  e.stopPropagation();
                  onShip();
                }}
                style={{ 
                  width: "100%", 
                  fontSize: "0.75rem", 
                  padding: "0.5rem",
                  ...(mailing.shipping_override?.enabled && mailing.shipping_override?.address_line1 ? {
                    background: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
                    boxShadow: "0 4px 12px rgba(249, 115, 22, 0.3)"
                  } : {})
                }}
              >
                <Truck size={14} />
                Ship{mailing.shipping_override?.enabled && mailing.shipping_override?.address_line1 ? " (Override)" : ""}
              </button>
            )}
          </>
        )}
        {hasShipments && (
          <button
            className="btn btn-sm"
            onClick={(e) => {
              e.stopPropagation();
              onViewShipment();
            }}
            style={{ 
              width: "100%", 
              fontSize: "0.75rem", 
              padding: "0.5rem",
              background: "#f59e0b",
              color: "white",
              border: "none"
            }}
          >
            <Truck size={14} />
            View Shipment
          </button>
        )}
        
        {/* PDF Buttons Grid - 2 columns */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem" }}>
          <button
            className="btn btn-sm btn-outline"
            onClick={(e) => {
              e.stopPropagation();
              onPreviewPDF('pvds');
            }}
            style={{ fontSize: "0.7rem", padding: "0.5rem" }}
          >
            <FileText size={14} />
            PVDS
          </button>
          
          <button
            className="btn btn-sm btn-outline"
            onClick={(e) => {
              e.stopPropagation();
              onPreviewPDF('facing');
            }}
            disabled={generatingPDF === 'facing'}
            style={{ fontSize: "0.7rem", padding: "0.5rem" }}
          >
            <FileText size={14} />
            {generatingPDF === 'facing' ? '...' : 'Facing'}
          </button>

          <button
            className="btn btn-sm btn-outline"
            onClick={(e) => {
              e.stopPropagation();
              onPreviewPDF('acceptance');
            }}
            disabled={!mailing.acceptance_pdf_template || generatingPDF === 'acceptance'}
            style={{ fontSize: "0.7rem", padding: "0.5rem" }}
            title={!mailing.acceptance_pdf_template ? "Upload Acceptance PDF in Edit Mailing" : "Generate Acceptance PDF"}
          >
            <FileCheck size={14} />
            {generatingPDF === 'acceptance' ? '...' : 'Acceptance'}
          </button>

          <button
            className="btn btn-sm btn-outline"
            onClick={(e) => {
              e.stopPropagation();
              onPreviewPDF('postage_statement');
            }}
            disabled={!mailing.postage_statement_template || generatingPDF === 'postage_statement'}
            style={{ fontSize: "0.7rem", padding: "0.5rem" }}
            title={!mailing.postage_statement_template ? "Upload Postage Statement PDF in Edit Mailing" : "Generate Postage Statement PDF"}
          >
            <FileText size={14} />
            {generatingPDF === 'postage_statement' ? '...' : 'Postage Stmt'}
          </button>

          <button
            className="btn btn-sm btn-outline"
            onClick={(e) => {
              e.stopPropagation();
              onPreviewPDF('labels');
            }}
            disabled={generatingPDF === 'labels' || !mailing.box_packing}
            title={!mailing.box_packing ? "Must pack boxes first" : "Generate Labels"}
            style={{ fontSize: "0.7rem", padding: "0.5rem", gridColumn: "1 / -1" }}
          >
            <Tag size={14} />
            {generatingPDF === 'labels' ? 'Generating...' : 'Labels'}
          </button>
        </div>

        <button
          className="btn btn-sm btn-outline"
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          style={{ width: "100%", color: "#dc2626", fontSize: "0.65rem", padding: "0.375rem" }}
        >
          <Trash2 size={12} />
          Delete
        </button>
      </div>
    </div>
  );
}